import React from 'react';
import { InputNumber } from '@components/framework/input/InputNumber';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';

interface UnitItem {
  label: string;
  value: string;
}

interface InputQuantityWithUnitProps {
  value: number;
  unit: string;
  disabled?: boolean;
  disabledCurrency?: boolean;
  changeValue: (value: number) => void;
  changeUnit: (unit: string) => void;
  code?: string;
  unitOptions: UnitItem[];
  companyId?: string;
}

const InputQuantityWithUnit: React.FC<InputQuantityWithUnitProps> = ({
                                                                       value,
                                                                       unit,
                                                                       changeValue,
                                                                       changeUnit,
                                                                       unitOptions,
                                                                       disabled = false,
                                                                     }) => {
  return (
    <>
      <div className={'flex flex-row w-full'}>
        <InputNumber
          className="p-text-right"
          minFractionDigits={0}
          maxFractionDigits={0}
          value={value}
          onValueChange={e => changeValue(e.value)}
          mode="decimal"
          disabled={disabled}
          locale={'cs'}
          inputStyle={{ textAlign: 'right', borderRight: 'none', width: '100%' }}
          style={{ width: '100%' }}
        />
        <Dropdown
          value={unit}
          options={unitOptions}
          optionLabel={'label'}
          optionValue={'value'}
          onChange={e => {
            console.log(e)
            changeUnit(e.target.value)}
          }
          disabled={disabled}
          required
        />
      </div>
    </>
  );
};

export default InputQuantityWithUnit;
